module.exports = __webpack_public_path__ + "img/logo14.4ab490c8.png";